import axios from '@axios'

export const state = {
  serviceCosts: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allServiceCosts: (state) => state.serviceCosts,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_SERVICE_COSTS: (state, resp) => {
    if (!resp) return null
    state.serviceCosts = resp.serviceCosts
  },
  CREATE_SERVICE_COST: (state, serviceCost) => {
    state.serviceCosts.unshift(serviceCost)
  },
  UPDATE_SERVICE_COST: (state, serviceCost) => {
    const index = state.serviceCosts.findIndex(
      (cost) => cost.id === serviceCost.id
    )
    if (index !== -1) {
      state.serviceCosts.splice(index, 1, serviceCost)
    }
  },
  DELETE_SERVICE_COST: (state, serviceCost) => {
    state.serviceCosts = state.serviceCosts.filter(
      (s) => s.id !== serviceCost.id
    )
  },
}

export const actions = {
  async getServiceCosts({ commit }) {
    await axios.get('/api/service-costs').then((resp) => {
      if (resp.status === 200) {
        commit('GET_SERVICE_COSTS', resp.data)
      }
    })
  },
  async multipleServiceCost({ commit, dispatch }, serviceCost) {
    return axios.post('/api/service-costs', serviceCost).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_SERVICE_COST', resp.data)
        dispatch('getServiceCosts') // Fetch updated service costs
      }
    })
  },
  async deleteServiceCost({ commit, dispatch }, serviceCost) {
    await axios
      .delete('/api/service-costs', { data: serviceCost })
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_SERVICE_COST', serviceCost)
          let notification = {
            id: Date.now(),
            type: 'success',
            title: 'DELETE',
            message: 'The serviceCost has been deleted',
          }
          dispatch('notification/addNotification', notification, { root: true })
        }
      })
  },
}
